import { render, staticRenderFns } from "./t-page-general.vue?vue&type=template&id=6126bb30&"
import script from "./t-page-general.vue?vue&type=script&lang=js&"
export * from "./t-page-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports